import Sidebar from '../component/dashboard/sidebar';
import Main from '../component/dashboard/main';
import Header from '../component/dashboard/header';
import { Stack, Box, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';

function Dashboardlayout() {
    const theme = useTheme();
    const [selectedPage, setSelectedPage] = useState("account");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const handlePageChange = (page) => {
        setSelectedPage(page);
    };
    const toggleSidebar = () => {
        setSidebarOpen((prev) => !prev);
    };
    return (
        <>
            <Stack direction={'column'} justifyContent={'start'} alignContent={'stretch'} height={'100vh'}>
                <Header />
                <Stack direction={'row'} justifyContent={'start'} height={{ xs: 'calc( 100% - 81px )', sm: 'calc( 100% - 85px )' }}>
                    <Stack
                        sx={{
                            width: '250px',
                            height: '100%',
                            // background: theme => theme.palette.primary.dark,
                            // position: sidebarOpen ? { xs: 'fixed', sm: "static" } : 'static',
                            display: sidebarOpen ? { xs: 'none', sm: "flex" } : 'none',
                            zIndex: '999999999'
                        }}
                        justifyContent={'space-between'}
                    >
                        <Sidebar onPageChange={handlePageChange} toggleSidebar={toggleSidebar} />
                    </Stack>
                    <Box
                        sx={{
                            width: sidebarOpen ? { xs: '100%', sm: 'calc( 100% - 250px)' } : '100%',
                            height: '100%',
                            background: theme => theme.palette.primary.dark2,
                            overflow: 'auto',
                        }}
                    >
                        <Main selectedPage={selectedPage} toggleSidebar={toggleSidebar} />
                    </Box>
                </Stack>
            </Stack>
        </>
    );
}

export default Dashboardlayout;